// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GhNb","index":"styles_index__1bHFs"};